<template>
  <div class="settings-integrations">
    <h1 class="settings-integrations__title">{{ $tr('integrations.integrations-list-title') }}</h1>

    <div v-if="integrationsClients.length > 0" class="settings-integrations__list">
      <div v-if="isIntegrationsClientsLoading" key="loader" class="settings-integrations__loading">
        <vpreloader :width="3" :size="44" />
      </div>

      <template v-else>
        <template v-if="integrationsClients">
          <div
            v-for="item in integrationsClients"
            :key="item.id"
            class="settings-integrations__list-item"
            @click="openIntegrationModal(item.id)"
          >
            <div
              v-if="installStatus(item) === 'warning'"
              v-tooltip="{
                content: $tr('integrations.install-warning'),
                placement: 'auto',
                classes: 'tight'
              }"
              class="settings-integrations__installed"
            >
              <img src="/static/icons/integration-warning.svg" alt="" />
            </div>

            <div
              v-if="installStatus(item) === 'success'"
              v-tooltip="{
                content: $tr('integrations.installed'),
                placement: 'auto',
                classes: 'tight'
              }"
              class="settings-integrations__installed"
            >
              <img src="/static/icons/integration-success.svg" alt="" />
            </div>

            <div :class="item.code" class="settings-integrations__list-item-top">
              <div v-if="item.logo" class="settings-integrations__list-item-logo" :class="item.code">
                <img v-if="item.code !== 'assessfirst'" :src="`/static/images/integrations/${item.code}.svg`" alt="" />
                <img v-else :src="`/static/images/integrations/${item.code}.png`" alt="" />
              </div>
            </div>

            <div class="settings-integrations__list-item-description">
              <div class="settings-integrations__list-item-description-head">
                {{ getTranslatedText(item.langs, 1) }}
              </div>
              <div class="settings-integrations__list-item-description-sub">
                {{ getTranslatedText(item.langs, 3) }}
              </div>
            </div>
          </div>
        </template>

        <div v-else key="empty-list" class="settings-integrations__list">
          <div class="settings-integrations__list-empty">
            {{ $tr('integrations.no-integrations') }}
          </div>
        </div>
      </template>
    </div>

    <!-- MODAL -->
    <vcv-settings-integrations-modal
      v-if="currentIntegration"
      :is-show="isIntegrationModalShow"
      :current-integration="currentIntegration"
      :title="getTranslatedText(currentIntegration.langs, 1)"
      :description="getTranslatedText(currentIntegration.langs, 2)"
      :description-short="getTranslatedText(currentIntegration.langs, 3)"
      :is-integration-installing="isIntegrationInstalling"
      @close-integration-modal="closeIntegrationModal()"
      @make-action="makeAction()"
    />
  </div>
</template>

<script>
// В данном компоненте встречаются отдельные методы из разных интеграций (во время установки),
// на следующих интеграциях необходимо написать более универсальные методы или дождаться сокетов и перевести все на них.
// Сейчас проблема в том что нужно делать периодические запросы на интеграционный сервис чтобы дождаться появления access_token
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Axios from 'axios';
import { promiseSleep } from '@/_helpers/utils';
import VcvSettingsIntegrationsModal from '@/routes_new/inner/settings/integrations/VcvSettingsIntegrationsModal';

export default {
  components: {
    VcvSettingsIntegrationsModal
  },

  data() {
    return {
      isIntegrationInstalling: false,
      isIntegrationModalShow: false,
      currentIntegration: null
    };
  },

  computed: {
    ...mapState('locale', { currentLocale: 'value' }),

    ...mapState('integrations', [
      'integrationsInstalls',
      'isIntegrationsInstallsLoaded',
      'isIntegrationsClientsLoading',
      'integrationsClients'
    ]),

    ...mapGetters('integrations', ['getIntegrationParams'])
  },

  async created() {
    await this.fetchIntegrationsClients();
  },

  methods: {
    ...mapMutations('integrations', ['SET_SPECIFIC_INTEGRATION_TOGGLE_INSTALLED']),

    ...mapActions('integrations', ['fetchIntegrationsInstalls', 'fetchIntegrationsClients']),

    ...mapActions('integrationsHeadhunter', ['startIntervalIntegrationCheckHeadhunter']),

    ...mapActions('integrationsHackerrank', ['startIntervalIntegrationCheckHackerrank']),

    ...mapActions('integrationsAssessfirst', ['startIntervalIntegrationCheckAssessfirst']),

    async openIntegrationModal(integrationId) {
      const integrationIndex = this.integrationsClients.findIndex(x => x.id === integrationId);

      if (integrationIndex >= 0) {
        this.currentIntegration = this.integrationsClients[integrationIndex];
        this.isIntegrationModalShow = true;
      }
    },

    closeIntegrationModal() {
      if (!this.isIntegrationsClientsLoading) {
        this.isIntegrationModalShow = false;
        this.currentIntegration = null;
      }
    },

    async makeAction() {
      if (this.currentIntegration.installed) {
        await this.makeUninstall();
      } else {
        await this.makeInstall();
      }
    },

    async makeInstall() {
      this.isIntegrationInstalling = true;

      await Axios.post(`oauth2/installs/${this.currentIntegration.id}?send_code=true`)
        .then(async () => {
          // Запрос installs делаем через время promise функции, чтобы интеграционный сервис успел обработать и выдать токен
          // То есть перед запросом ставим паузу
          await promiseSleep(2000);
        })
        .then(async () => {
          // Далее запрашиваем все installs (где запрашиваем есть ли токен)
          // Записываем эти данные в state.integrations.integrationsInstalls
          await this.fetchIntegrationsInstalls();

          // Устанавливаем флаг installed для интеграции в store, чтобы не запрашивать все интеграции заново после установки.
          this.SET_SPECIFIC_INTEGRATION_TOGGLE_INSTALLED({
            id: this.currentIntegration.id,
            installed: true
          });

          // Исключения для отдельных интеграций
          if (this.currentIntegration.code === 'headhunter') {
            this.startIntervalIntegrationCheckHeadhunter();
          }
          if (this.currentIntegration.code === 'hackerrank') {
            this.startIntervalIntegrationCheckHackerrank();
          }
          if (this.currentIntegration.code === 'assessfirst') {
            this.startIntervalIntegrationCheckAssessfirst();
          }
          // Конец исключений для отдельных интеграций

          this.$noty.success(this.$tr('integrations.install-success'));
        })
        .catch(() => {
          this.$noty.error(this.$tr('common.error'));
        })
        .finally(() => {
          this.isIntegrationInstalling = false;
        });
    },

    async makeUninstall() {
      this.isIntegrationInstalling = true;

      await Axios.delete(`oauth2/installs/${this.currentIntegration.id}`)
        .then(() => {
          this.SET_SPECIFIC_INTEGRATION_TOGGLE_INSTALLED({
            id: this.currentIntegration.id,
            installed: false
          });
          this.closeIntegrationModal();
          this.$noty.success(this.$tr('integrations.uninstall-success'));
        })
        .catch(() => {
          this.$noty.error(this.$tr('common.error'));
        })
        .finally(() => {
          this.isIntegrationInstalling = false;
        });
    },

    // Types
    // 1: Title
    // 2: Description
    // 3: Short description
    getTranslatedText(langs, type) {
      const titleObject = langs.find(x => x.language.code === this.currentLocale && x.type === type);

      return titleObject.text;
    },

    installStatus(item) {
      if (item.installed && this.getIntegrationParams(item.code).installStatus === false) {
        return 'warning';
      }

      if (
        item.installed &&
        (this.getIntegrationParams(item.code).installStatus ||
          this.getIntegrationParams(item.code).installStatus === undefined)
      ) {
        return 'success';
      }

      return '';
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/fonts.scss';

.settings-integrations {
  &__title {
    @include mixin-text-header-bigger;
  }

  &__list {
    margin: 30px 0;
    display: flex;
    flex-wrap: wrap;
  }

  &__list-empty {
    padding: 50px 0;
    text-align: center;
    color: #aaa;
  }

  &__loading {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__list-item {
    width: 288px;
    height: 250px;
    background: #ffffff;
    box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 24px;
    margin-bottom: 24px;
    position: relative;
    transition: box-shadow 0.5s;

    &:hover {
      box-shadow: 0px 0px 35px 5px rgba(35, 51, 70, 0.15);
      transition: box-shadow 0.5s;
    }
  }

  &__installed {
    position: absolute;
    bottom: 8px;
    right: 8px;
  }

  &__list-item-top {
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.headhunter {
      background: #d20c11;
    }

    &.hackerrank {
      background: #39424e;
    }

    &.hrm {
      background: #deed33;
    }
  }

  &__list-item-logo {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      display: block;
      width: 100%;
      height: auto;
    }

    &.hrm {
      width: 130px;
      height: 130px;
    }
  }

  &__list-item-description {
    height: 80px;
    background: #fff;
    padding: 20px 16px;
  }

  &__list-item-description-head {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 4px;
  }

  &__list-item-description-sub {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #9faab6;
  }
}
</style>
